import Script from "next/script"
import React from "react"

import { container } from "./InstagramEmbed.css"

type Props = {
  id: string
}

export const InstagramEmbed: React.FC<Props> = ({ id }) => {
  return (
    <div className={container}>
      <blockquote
        className="instagram-media"
        data-instgrm-permalink={id}
        data-instgrm-version="14"
      />
      <Script async src="//www.instagram.com/embed.js" type="text/javascript" />
    </div>
  )
}
